// extracted by mini-css-extract-plugin
export default {"container":"Bp-z","heading":"Cp-z","text":"Dp-z","info":"Ep-z","link":"Fp-z","fullMaxWidth":"Gp-z"};